import React, { Component } from 'react';
import { connect } from 'react-redux';
import SubscribePage from './subscribePage';
import {isosLogo} from '../../conf/config';
import { getTenantInfo } from '../../api';
import PageNotFound from '../../component/404';
import dropDownEvent from '../../component/dropDownEvent';
import NoType from '../../component/alert/noType';
import NoCountry from '../../component/alert/noCountry';
import {checkdomain} from "../../utils/utils";

@connect(
  state=>state.page,
  null
)
class Subscribe extends Component{
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      companyName: '',
      pageNotFound: false,
      logo: '',
      pageStyle: {
        fontFamily: '',
        subBtnFontColor: '',
        unSubBtnFontColor: '',
        headlineColor: '',
        subBtnBgColor: '',
        unSubBtnBgColor: ''
      }
    };
  }

  componentWillMount() {
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      return this.props.history.push("/admin");
      // return this.setState({pageNotFound: true});
    }
    this.setState({name: tenantname});
    getTenantInfo({}, {headers: {'tenantname': tenantname}})
      .then(res => {
        let data = res.data || {};
        this.setState({
          companyName: data.companyName,
          logo: data.logo,
          pageStyle: {
            fontFamily: data.fontFamily,
            subBtnFontColor: data.subBtnFontColor,
            unSubBtnFontColor: data.unSubBtnFontColor,
            headlineColor: data.headlineColor,
            subBtnBgColor: data.subBtnBgColor,
            unSubBtnBgColor: data.unSubBtnBgColor
          }
        })
      })
      .catch(err=>{
        console.log(err);
        if (err.message && err.message === "The tenant was not found.") {
          this.setState({pageNotFound: true});
        }
      });
  }

  componentDidMount() {
    dropDownEvent();
  }

  render() {
    let { name, companyName, logo, pageNotFound, pageStyle } = this.state;
    if (pageNotFound) {
      return <PageNotFound />;
    }
    return (
      <div>
        <div className="modal fade" id="hasSelectAll_modal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title"> Alert </h4>
              </div>
              <div className="modal-body">
                <div className="alert alert-block">
                  <h4 className="alert-heading">All countries have been selected.</h4>
                  <p>You have selected all countries. If you want to select specific countries, please unselect the “All” countries setting.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="login animated fadeInDown bg-white">
          <header className="header">
            <img
              className="img-responsive center-block"
              src={logo}
              style={{maxHeight: 130}}/>
            <img
              alt="creative star"
              style={{color: '#fff'}}
              className="img-responsive center-block"
              src={isosLogo}/>
          </header>
          <div className="main" role="main">
            <SubscribePage name={name} companyName={companyName} pageStyle={pageStyle} />
          </div>
        </div>
        <NoType />
        <NoCountry />
      </div>
    );
  }
}

export default Subscribe;


// WEBPACK FOOTER //
// ./src/container/subscribe/index.js